import { DummyStore } from 'src/stores';

import { SystemUser } from '../types';

export namespace SystemUserViewStore {
  export const profile = new DummyStore<SystemUser>();
}
